// bao migrate skip
import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-toolbar2";
import Bao from "./../../services/bao-service";
import * as $ from "jquery";
import * as ko from "knockout";
import GenericListTab from "./../../factories/generic-list-tab";
import BaoDialog from "./../../factories/bao-dialog";
import baoRouter from "./../../services/bao-router";
class ShiftbookUniversalField extends GenericListTab {
    constructor(tabPage: TabPage, parent) {
        super(tabPage, parent);
        this.SaveAllowed = parent.SaveAllowed;
        this.Models.subscribe(() => {
            this.Selection([]);
        });
    }
    SaveAllowed: KnockoutObservable<boolean>;
    ControllerUrl = "ShiftbookUniversalField";
    CustomFilter(): Models.HashObject[] {
        return null;
    }
    ToggleToolbarButtons() {
        super.ToggleToolbarButtons();
        ko.utils.arrayForEach(this.ToolbarButtons(), (button: any) => {
            var key = ko.unwrap(button.ActionKey);
            if (key === "ShiftbookUniversalFieldMoveUp" || key === "ShiftbookUniversalFieldMoveDown") {
                button.Enabled(this.Selection() != null && this.Selection().length > 0);
            }
        });
    }
    CustomToolbarClick = (action: Interfaces.Bao.BaoMenuItem) => {
        var key = ko.unwrap(action.ActionKey);
        if (key === "ShiftbookUniversalFieldMoveUp") {
            this.moveShiftbookUniversalField("MoveUp");
        }
        else if (key === "ShiftbookUniversalFieldMoveDown") {
            this.moveShiftbookUniversalField("MoveDown");
        }
    };
    ItemCompleteCheck(): JQueryPromise<boolean> {
        var def = $.Deferred<boolean>();
        def.resolve(true);
        return def.promise();
    }
    public Edit(item) {
        if (item != null) {
            this.Dialog(ko.unwrap(item.PrimaryKeyValue));
        }
    }
    CompleteCheck(): JQueryPromise<boolean> {
        return Bao.post("ShiftbookUniversalField/CompleteCheck", JSON.stringify({
            shiftbookId: this.GetParentId(),
            sessionTabId: this.SessionTabId
        }))
            .then((result: any) => {
                if (!result.Result) {
                    new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgShiftbookAssigmentCompleteCheckErrorNotUpToDate"), "info");
                    return false;
                }
                return true;
        });
    }
    private moveShiftbookUniversalField = (action: string) => {
        this.TabPage.IsLoading(true);
        var selection = this.Selection();
        var guidList = [];
        ko.utils.arrayForEach(selection, function (item) {
            guidList.push(ko.unwrap(item.ShiftbookUniversalFieldId));
        });
        Bao.post("ShiftbookUniversalField/" + action + "ShiftbookUniversalField", JSON.stringify({
            sessionTabId: this.SessionTabId,
            id: guidList
        })).done(result => {
            this.Get();
        });
    };
    link(index: number, model) {
        var linkHash = 'universalField/' + model.UniversalFieldId;
        baoRouter.setHash(linkHash);
    }
}
export default ShiftbookUniversalField;